(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jof-collection-editorial"]) return;
  try {
    
  (() => {
    if (!window.matchMedia('(max-width: 899px) and (prefers-reduced-motion: no-preference)').matches || !('IntersectionObserver' in window)) return;

    const observed = new WeakSet();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('jof-editorial__quick-add--nudge');
        observer.unobserve(entry.target);
      });
    }, { threshold: 1 });

    const observeButtons = (root = document) => {
      root.querySelectorAll('.jof-editorial__quick-add:not(.jof-editorial__quick-add--supporting)').forEach((button) => {
        if (observed.has(button)) return;
        observed.add(button);
        observer.observe(button);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => observeButtons(), { once: true });
    } else {
      observeButtons();
    }
    document.addEventListener('shopify:section:load', (event) => observeButtons(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
